<template>
    <div>
        Rate - Supply
    </div>
</template>

<script setup lang="ts"></script>
